// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

// --- RxJs
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

// --- 3rd Party
import { retryBackoff } from 'backoff-rxjs';
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import { environment } from '../../../../environments/environment';
import { ApplicationError, ErrorMessage, PatchModel, PatchOperations, UserCommunicationsModel } from '../../../models';
import { AppService } from '../app.service';
import { CommunicationsBaseService } from './communications-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class CommunicationsService extends CommunicationsBaseService {

  constructor(private http: HttpClient, private appService: AppService, private translate: TranslateService) {
    super();
  }

  loadUserCommunicationPreferences(): void {
    const url = environment.apiConfig.surveyApiUrl + environment.apiConfig.communicationsApi;

    this.http.get<UserCommunicationsModel>(url).pipe(
      retryBackoff(environment.retryConfig),
      catchError(this._modelError.bind(this))
    ).subscribe((ucm: UserCommunicationsModel | null) => {
      if (!ucm) return;

      this._showSurveyNotifications$.next(ucm.showSurveyNotifications);
      this._showUpdatesInspirationOffers$.next(ucm.showUpdatesInspirationOffers);
    });
  }

  setShowSurveyNotifications(value: boolean): void {
    if (value === null || typeof value === 'undefined') {
      return;
    }

    this._updateCommunicationSetting(value, 'ShowSurveyUpdates');
  }

  setShowUpdates(value: boolean): void {
    if (value === null || typeof value === 'undefined') {
      return;
    }

    this._updateCommunicationSetting(value, 'ShowUpdatesInspirationOffers');
  }

  private _updateCommunicationSetting(value: boolean, valueToUpdate: string) {
    const url = environment.apiConfig.surveyApiUrl + environment.apiConfig.communicationsApi;

    const model = {
      operation: PatchOperations.replace,
      path: valueToUpdate,
      value: value.toString()
    } as PatchModel;

    this.http.patch<UserCommunicationsModel>(url, model).pipe(
      retryBackoff(environment.retryConfig),
      catchError(this._modelError.bind(this))
    ).subscribe((ucm: UserCommunicationsModel | null) => {
      if (!ucm) return;

      this._showSurveyNotifications$.next(ucm.showSurveyNotifications);
      this._showUpdatesInspirationOffers$.next(ucm.showUpdatesInspirationOffers);
    });

  }

  private _modelError(err: any): Observable<UserCommunicationsModel | null> {
    this._handleError(err);
    return of(null);
  }

  private _handleError(err: any) {
    this.appService.setLoading(false);

    const error: ApplicationError = ApplicationError.create(
      ErrorMessage.genericErrorCode,
      'CommunicationsService',
      false,
      err
    );

    this.appService.setLastError(error);
  }

}
